import { Routes, Route } from 'react-router-dom'
import Layout from './components/layout/Layout'
import Home from './pages/Home/Home'
import About from './pages/About/About'
import Contact from './pages/Contact/Contact'
import Services from './pages/Services/Services'
import ConventionalPOR from './pages/Services/ConventionalPOR'
import MerkleTreePOR from './pages/Services/MerkleTreePOR'
import OnChainPOR from './pages/Services/OnChainPOR'
import RealTimePOR from './pages/Services/RealTimePOR'
import FinancialStatementAudit from './pages/Services/FinancialStatementAudit'
import InternalControlExaminations from './pages/Services/InternalControlExaminations'
import CryptoTaxServices from './pages/Services/CryptoTaxServices'
import OutsourcedAccounting from './pages/Services/OutsourcedAccounting'
import Attestations from './pages/Attestations/Attestations'
import StablecoinIssuers from './pages/MarketSegments/StablecoinIssuers'
import RWATokenIssuers from './pages/MarketSegments/RWATokenIssuers'
import ExchangesCustodians from './pages/MarketSegments/ExchangesCustodians'
import DAOs from './pages/MarketSegments/DAOs'
import PaymentProcessors from './pages/MarketSegments/PaymentProcessors'
import CryptoFintechs from './pages/MarketSegments/CryptoFintechs'
import Blog from './pages/Blog/Blog'
import BlogPost from './pages/Blog/BlogPost'
import NotFound from './pages/NotFound/NotFound'

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/conventional-proof-of-reserves" element={<ConventionalPOR />} />
        <Route path="/services/merkle-tree-proof-of-reserves" element={<MerkleTreePOR />} />
        <Route path="/services/on-chain-proof-of-reserves" element={<OnChainPOR />} />
        <Route path="/services/real-time-proof-of-reserves" element={<RealTimePOR />} />
        <Route path="/services/financial-statement-audit" element={<FinancialStatementAudit />} />
        <Route path="/services/internal-control-examinations" element={<InternalControlExaminations />} />
        <Route path="/services/crypto-tax-services" element={<CryptoTaxServices />} />
        <Route path="/services/outsourced-accounting" element={<OutsourcedAccounting />} />
        <Route path="/attestations" element={<Attestations />} />
        <Route path="/market-segments/stablecoin-issuers" element={<StablecoinIssuers />} />
        <Route path="/market-segments/rwa-token-issuers" element={<RWATokenIssuers />} />
        <Route path="/market-segments/exchanges-custodians" element={<ExchangesCustodians />} />
        <Route path="/market-segments/exchanges" element={<ExchangesCustodians />} />
        <Route path="/market-segments/daos" element={<DAOs />} />
        <Route path="/market-segments/payment-processors" element={<PaymentProcessors />} />
        <Route path="/market-segments/crypto-fintechs" element={<CryptoFintechs />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  )
}

export default App